import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCreditCard, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons'
import { haptic } from '../../../utils/fx'

interface PaymentSelectorProps {
  payment: { label: string; value: string }
  setPayment: (value: { label: string; value: string }) => void
  paymentMethods: { label: string; value: string }[]
}

const PAYMENT_ICONS: Record<string, IconDefinition> = {
  '1': faMoneyBillWave,
  '2': faCreditCard,
}

const PaymentSelector: React.FC<PaymentSelectorProps> = ({
  payment,
  setPayment,
  paymentMethods,
}) => (
  <div className='checkout-page__payment' role='radiogroup'>
    {paymentMethods.map((item) => {
      const active = item.value === payment.value

      return (
        <button
          key={item.value}
          role='radio'
          aria-checked={active}
          className={`checkout-page__payment-item${active ? ' is-active' : ''}`}
          onClick={() => {
            haptic(8)
            setPayment(item)
          }}
        >
          <span className='checkout-page__payment-icon'>
            <FontAwesomeIcon icon={PAYMENT_ICONS[item.value] ?? faMoneyBillWave} />
          </span>
          <span className='checkout-page__payment-label'>{item.label}</span>
          <span className='checkout-page__payment-check' />
        </button>
      )
    })}
  </div>
)

export default PaymentSelector
